import { c as _c } from "react/compiler-runtime";
import Grid from '@precis-digital/kurama/Grid';
import SparkleIcon from '@precis-digital/kurama/icons/SparkleIcon';
import { type ReactElement } from 'react';
import { useCopilot } from 'shared/context/CopilotContext';
import CopilotPrePromptButton from './CopilotPrePromptButton';
const MAX_SUGGESTED_PROMPTS = 2;

/**
 * Empty-chat suggested prompt cards (max 2) for MessageLayout `composerTopAccessory`.
 * Returns null when the page has no suggested prompts so the dock divider stays default.
 */
export const useCopilotSuggestedPromptsAccessory = () => {
  const $ = _c(13);
  const {
    currentPageContext
  } = useCopilot();
  let T0;
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== currentPageContext?.suggestedPrompts) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const suggestedPrompts = (currentPageContext?.suggestedPrompts ?? []).slice(0, MAX_SUGGESTED_PROMPTS);
      if (suggestedPrompts.length === 0) {
        t4 = null;
        break bb0;
      }
      T0 = Grid;
      t0 = true;
      t1 = "column";
      t2 = "8px";
      t3 = suggestedPrompts.map(_temp);
    }
    $[0] = currentPageContext?.suggestedPrompts;
    $[1] = T0;
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    T0 = $[1];
    t0 = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  let t5;
  if ($[7] !== T0 || $[8] !== t0 || $[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
    t5 = <T0 container={t0} direction={t1} gap={t2}>{t3}</T0>;
    $[7] = T0;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
function _temp(prompt) {
  return <CopilotPrePromptButton key={prompt.label} icon={<SparkleIcon />} label={prompt.label} message={prompt.message} />;
}